import React from 'react';
import PropTypes from 'prop-types';

const IconPhone = props => {
  const color = props.color || '#585858';
  return (
    <svg width={19} height={24} {...props} viewBox="0 0 19 24">
      <g stroke={color} strokeWidth={1.5} fill="none" fillRule="evenodd">
        <path d="M16.098 23H2.903A1.903 1.903 0 011 21.098V2.902C1 1.852 1.852 1 2.903 1h13.195C17.149 1 18 1.852 18 2.902v18.196c0 1.05-.851 1.902-1.902 1.902zM6.5 18h6" />
      </g>
    </svg>
  );
};

IconPhone.propTypes = {
  color: PropTypes.string,
};

export default IconPhone;
